<div class="login-page">
    <section class="login-card">
        <h1>Login to Workflow with</h1>
        <div class="login-actions">
            <app-flat-button
                (clicked)="loginWithWorkflowCredentials()"
                variant="status-blue">
                Workflow Credentials
            </app-flat-button>
            <app-flat-button (clicked)="loginWithSso()" variant="status-blue">
                SSO
            </app-flat-button>
        </div>
    </section>

    <section class="login-help text-sm">
        <p>
            <span class="text-semi">Choose how to sign in:</span>
            Select <span class="text-semi">SSO</span> only if GE Aerospace has
            confirmed your company SSO is enabled for your account. Otherwise,
            select <span class="text-semi">Workflow Credentials</span> to sign
            in with your Workflow username and password.
        </p>
        <p>
            If this is your first time signing in, your organization's account
            admin must assign you a role.
        </p>
    </section>
</div>
